import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.css']
})
export class LogoComponent {
  _normalLogoURL = 'assets/logo/logo.png';
  _lightLogoURL = 'assets/logo/logo-light.png';
  overlay: 'normal' | 'white' = 'normal';
  type: 'icon' | 'logo' = 'logo';
  @Input() classes: string = 'h-35px h-lg-45px';


  @Input('type') set logoType(value: 'icon' | 'logo') {
    this.type = value;
    switch (value) {
      case 'icon':
        this._normalLogoURL = 'assets/logo/logo-icon.png';
        this._lightLogoURL = 'assets/logo/logo-icon-light.png';
        
        break;
      case 'logo':
        this._normalLogoURL = 'assets/logo/logo.png';
        this._lightLogoURL = 'assets/logo/logo-light.png';
      break;
      default:
        break;
    }
  }

  @Input('overlay') set logoOverlay(value : 'normal' | 'white') {
    this.overlay = value;
  }
}
